import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Theme } from '@/types';

interface ThemeState {
  theme: Theme;
  resolvedTheme: 'light' | 'dark';
  setTheme: (theme: Theme) => void;
}

function applyLightTheme() {
  const root = document.documentElement;
  root.classList.remove('dark');
  root.classList.add('light');
  root.style.colorScheme = 'light';
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'light',
      resolvedTheme: 'light',
      setTheme: (_theme: Theme) => {
        // App is light-mode only
        applyLightTheme();
        set({ theme: 'light', resolvedTheme: 'light' });
      },
    }),
    {
      name: 'sanjoy_theme',
      onRehydrateStorage: () => (state) => {
        applyLightTheme();
        if (state) {
          state.theme = 'light';
          state.resolvedTheme = 'light';
        }
      },
    },
  ),
);

if (typeof window !== 'undefined') {
  applyLightTheme();
}
